import { render, staticRenderFns } from "./LocalActivities.vue?vue&type=template&id=2cc1b952&scoped=true&"
import script from "./LocalActivities.vue?vue&type=script&lang=js&"
export * from "./LocalActivities.vue?vue&type=script&lang=js&"
import style0 from "./LocalActivities.vue?vue&type=style&index=0&id=2cc1b952&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc1b952",
  null
  
)

export default component.exports